angular.module('gym').factory('AvailablePaymentProvidersService', ["$rootScope", "MasqueradingService", function($rootScope, MasqueradingService) {
  var country, gym, isMasquerading;
  gym = $rootScope.gym;
  country = gym.country;
  isMasquerading = MasqueradingService.isMasquerading();
  return {
    get: function() {
      switch (country) {
        case 'US':
          return ['bluefin', 'stripe', 'integrapay'];
        case 'CA':
          return ['bluefin', 'stripe'];
        case 'AU':
          if (isMasquerading) {
            return ['ezidebit', 'stripe', 'integrapay'];
          } else {
            return ['ezidebit'];
          }
          break;
        case 'NZ':
          if (isMasquerading) {
            return ['ezidebit', 'stripe', 'integrapay'];
          } else {
            return ['ezidebit'];
          }
          break;
        case 'GB':
          if (gym.gocardless_available) {
            return ['stripe', 'gocardless'];
          } else {
            return ['stripe'];
          }
          break;
        case 'DK':
          return ['stripe'];
        case 'IT':
          return ['stripe'];
        case 'AT':
          return ['stripe'];
        case 'GR':
          return ['stripe'];
        case 'MX':
          return ['stripe'];
        case 'BH':
          return [];
        case 'RO':
          return ['stripe'];
        case 'MV':
          return [];
        case 'CY':
          return ['stripe'];
        case 'ZA':
          return [];
        case 'OM':
          return [];
        case 'TN':
          return [];
        case 'AW':
          return [];
        case 'TT':
          return [];
        case 'DO':
          return [];
        case 'PH':
          return [];
        case 'KE':
          return [];
        case 'MM':
          return [];
        case 'IN':
          return [];
        case 'ID':
          return [];
        case 'PK':
          return [];
        case 'JM':
          return [];
        case 'MY':
          return ['stripe'];
        case 'SA':
          return [];
        case 'AE':
          return ['stripe'];
        case 'LT':
          return ['stripe'];
        case 'MT':
          return ['stripe'];
        case 'CH':
          return ['stripe'];
        case 'HK':
          return ['stripe'];
        case 'TH':
          return ['stripe'];
        case 'IE':
          return ['stripe'];
        case 'DE':
          return ['stripe'];
        case 'FI':
          return ['stripe'];
        case 'FR':
          return ['stripe'];
        case 'NO':
          return ['stripe'];
        case 'SE':
          return ['stripe'];
        case 'ES':
          return ['stripe'];
        case 'LU':
          return ['stripe'];
        case 'SG':
          return ['stripe'];
        case 'JP':
          return ['stripe'];
        case 'NL':
          return ['stripe'];
        case 'BE':
          return ['stripe'];
      }
    }
  };
}]);
